// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Form
//https://shopware-pwa-docs.vuestorefront.io/guide/CMS.html#block
const tData4 = {
    eMailAddress: "S.Guenther@GoetzGuenther.de",
    salutation: "Herr",
    Titel: "",
    Nachname: "Günther",
    Vorname: "Sebastian",
    Telefonnummer: "+49 371 77 41 46 0",
    Gruppe: "Mitglied",
    Verwaltungsbehörde: "AK-Berlin",
    Mitgliedsnummer: "00001"
};
const tData3 = {
    categories: [
        {
            name: "profile",
            displayName: "Mein Profil",
            properties: [
                {
                    name: "eMailAddress",
                    displayName: "E-Mail-Adresse (Benutzername)",
                    isReadOnly: true
                },
                {
                    name: "salutation",
                    displayName: "Anrede",
                    fieldType: "select",
                    attributes: {
                        itemSource: [
                            {
                                name: "Herr",
                                caption: "Herr"
                            },
                            {
                                name: "Frau",
                                caption: "Frau"
                            }
                        ],
                        valueExpr: "name",
                        displayExpr: "caption"
                    }
                },
                {
                    name: "Titel",
                    displayName: "Titel"
                },
                {
                    name: "Nachname",
                    displayName: "Nachname"
                },
                {
                    name: "Vorname",
                    displayName: "Vorname"
                },
                {
                    name: "Telefonnummer",
                    displayName: "Telefonnummer",
                    attributes: {
                        mode: "phone"
                    }
                },
                {
                    name: "Gruppe",
                    displayName: "Gruppe",
                    isReadOnly: true
                },
                {
                    name: "Verwaltungsbehörde",
                    displayName: "Verwaltungsbehörde",
                    isReadOnly: true
                },
                {
                    name: "Mitgliedsnummer",
                    displayName: "Mitgliedsnummer",
                    isReadOnly: true
                }
            ]
        },
        {
            name: "account",
            displayName: "Mein Account",
            properties: [
                {
                    name: "Name1",
                    displayName: "Name 1"
                },
                {
                    name: "Name2",
                    displayName: "Name 2"
                },
                {
                    name: "Name3",
                    displayName: "Name 3"
                },
                {
                    name: "street",
                    displayName: "Straße / Hausnummer"
                },
                {
                    name: "plz",
                    displayName: "Postleitzahl"
                },
                {
                    name: "ort",
                    displayName: "Ort"
                },
                {
                    name: "land",
                    displayName: "Land"
                },
                {
                    name: "Steuernummer",
                    displayName: "Steuernummer"
                },
                {
                    name: "EU-Ust.ID",
                    displayName: "EU-Ust.ID"
                },
            ]
        }
    ]
};
const tData2 = {
    name: 'test-456',
    type: 'container',
    toolbar: {
        commands: [
            {
                title: "Prüfen"
            },
            {
                title: "Reorganisieren"
            }
        ]
    },
    slots: [
        {
            type: "g-text-field",
            config: {
                label: "E-Mail-Adresse (Benutzername)",
                mode: "email",
                readOnly: true
            }
        },
        {
            type: "g-cms-separator",
            config: {
                class: "separator-solid"
            }
        },
        {
            type: "g-row-column-multi",
            slots: [
                {
                    _column: {
                        class: "col-6"
                    },
                    type: "g-select-field",
                    config: {
                        label: "Anrede",
                        valueExpr: "key",
                        displayExpr: "caption",
                        itemSource: [
                            {
                                key: "Herr",
                                caption: "Herr",
                            },
                            {
                                key: "Frau",
                                caption: "Frau",
                            }
                        ]
                    }
                }
            ]
        }
    ]
};
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-prototyp-page',
    // #endregion
    // #region Data
    data: () => ({
        _partID: '',
        _statusCode: 0,
        _content: tData2,
        _schema: {},
        _data: {}
    }),
    // #endregion
    // #region Constructor
    created() {
        host.api.get("identity/profile?mode=property").then(e => {
            this._schema = e.data.schema;
            this._data = e.data.data;
        });
    },
    // #endregion
    // #region Watch
    '$route.params.partID': function (value) {
        // #region Check
        if (utils.isNullOrEmpty(value)) {
            return;
        }
        // #endregion
        this._partID = value;
    },
    // #endregion
    // #region Core
    methods: {
        onCommand(args) {
            if (args.command === 'status_changed') {
                this._statusCode = args.statusCode;
            }
        }
    }
    // #endregion
});
// #endregion
